"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryPickupEventResolutionUpdate = exports.DeliveryPickupEventResolutionCreate = exports.DeliveryPickupEventResolutionQuery = exports.DeliveryPickupEventResolutionTransport = exports.DeliveryPickupEventResolution = exports.DeliveryPickupEventResolutionTypeLabels = exports.DeliveryPickupEventResolutionType = exports.DeliveryPickupEventResolutionTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const CommercialLineItem_1 = require("../subscriptions-and-billing/CommercialLineItem");
exports.DeliveryPickupEventResolutionTypes = [
    /**
     * The delivery was attempted, but failed. A new attempt will be made, with a new stop created in the database.
     */
    'REATTEMPT_DELIVERY',
    /**
     * The removal was attempted, but failed. A new attempt will be made, with a new stop created in the database.
     */
    'REATTEMPT_REMOVAL',
    /**
     * Add a charge to the customer's account for resolution of this event.
     */
    'ADD_CHARGE',
    /**
     * Add a discount to the customer's account for resolution of this event.
     */
    'ADD_DISCOUNT',
    /**
     * Container delivery is impossible, or service otherwise cannot be provided.
     */
    'CANCEL_SERVICE',
    /**
     * The event is self-resolving and no further action is needed, or the event was resolved through manual intervention and requires no automated actions.
     */
    'DO_NOTHING',
];
exports.DeliveryPickupEventResolutionType = typebox_1.Type.Union(exports.DeliveryPickupEventResolutionTypes.map((val) => typebox_1.Type.Literal(val)));
exports.DeliveryPickupEventResolutionTypeLabels = {
    REATTEMPT_DELIVERY: {
        singular: 'Reattempt Delivery',
    },
    REATTEMPT_REMOVAL: {
        singular: 'Reattempt Removal',
    },
    ADD_CHARGE: {
        singular: 'Add Charge',
    },
    ADD_DISCOUNT: {
        singular: 'Add Discount',
    },
    CANCEL_SERVICE: {
        singular: 'Cancel Service',
    },
    DO_NOTHING: {
        singular: 'Do Nothing',
    },
};
exports.DeliveryPickupEventResolution = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    // event: DeliveryPickupRouteEvent,
    deliveryPickupEventID: typebox_1.Type.String({ format: 'uuid' }),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    resolvedAt: typebox_1.Type.String({ format: 'date-time' }),
    type: exports.DeliveryPickupEventResolutionType,
    replacementDeliveryPickupStopID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    lineItem: typebox_1.Type.Optional(CommercialLineItem_1.CommercialLineItemTransport),
    metadata: common_1.MetaData,
});
exports.DeliveryPickupEventResolutionTransport = exports.DeliveryPickupEventResolution;
exports.DeliveryPickupEventResolutionQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        customerID: typebox_1.Type.String({ format: 'uuid' }),
        deliveryPickupEventID: typebox_1.Type.String({ format: 'uuid' }),
        resolvedBefore: typebox_1.Type.String({ format: 'date-time' }),
        resolvedAfter: typebox_1.Type.String({ format: 'date-time' }),
    }),
]));
exports.DeliveryPickupEventResolutionCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.DeliveryPickupEventResolution, [
        'id',
        'haulerID',
        'customerID',
        'resolvedAt',
        'lineItem',
        'replacementDeliveryPickupStopID',
        'metadata',
    ]),
    typebox_1.Type.Object({
        resolvedAt: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })), // Will default to current date/time if not provided.
        lineItem: typebox_1.Type.Optional(CommercialLineItem_1.CommercialLineItemCreate),
        createReplacementStop: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    }),
]);
exports.DeliveryPickupEventResolutionUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.DeliveryPickupEventResolution, [
        'id',
        'haulerID',
        'customerID',
        'deliveryPickupEventID',
        'notes',
        'metadata',
    ]),
    typebox_1.Type.Object({
        notes: (0, common_1.Nullable)(typebox_1.Type.String()),
    }),
]));
//# sourceMappingURL=DeliveryPickupEventResolution.js.map